import { Card, Carousel, Col, Row, Tag } from "antd";

export default function VisitOne() {
  return (
    <>
      <Row gutter={[16, 16]} wrap={false}>
        <Col flex="0 0 338px">
          <h3 style={{ marginBottom: "8px" }}> Visit 3 - Mar 17 </h3>
          <Card className="reviewClient">
            <div
              style={{
                display: "flex",
                marginBottom: "8px",
                gap: "8px",
                alignItems: "center",
                padding: "10px 8px 0px 8px",
              }}
            >
              <img
                src="/images/dummy/user.png"
                alt=""
                style={{ width: "32px", height: "32px" }}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h4
                  style={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "600",
                    color: "#151718",
                  }}
                >
                  Jake Ryan
                </h4>
                <p
                  style={{
                    fontSize: "12px",
                    lineHeight: "16px",
                    fontWeight: "400",
                    color: "#6C5D06",
                  }}
                >
                  Crew LM 1
                </p>
              </div>
            </div>
            <div
              style={{
                backgroundColor: "#fff",
                padding: "16px",
                borderRadius: "12px",
              }}
            >
              <p>
                Completed all scheduled tasks for this visit. Mowed the lawn, 
                trimmed hedges, and removed debris from flower beds. 
                Everything looks good — no issues to report.
              </p>
            </div>
          </Card>

          <Card className="jobEndChecklist">
            <h4 style={{ marginBottom: "12px" }}> End-of-job checklist </h4>
            <ul className="checkList">
              <li>
                <img src="/images/work-orders/checkGreyIcon.svg" alt="" />
                Use 21" mower for small areas near pathways.
              </li>
              <li>
                <img src="/images/work-orders/checkGreyIcon.svg" alt="" />
                Hard edging along sidewalks and driveway (500 lf).
              </li>
              <li>
                <img src="/images/work-orders/checkGreyIcon.svg" alt="" />
                Soft edging around all flower beds and tree rings.
              </li>
              <li>
                <img src="/images/work-orders/checkGreyIcon.svg" alt="" />
                Clear all hard surfaces of debris after mowing and edging.
              </li>
              <li>
                <img src="/images/work-orders/checkGreyIcon.svg" alt="" />
                Check for signs of irrigation issues (wet patches or leaks).
              </li>
              <li>
                <img src="/images/work-orders/checkGreyIcon.svg" alt="" />
                Report any damaged areas or concerns in the crew notes.
              </li>
            </ul>
          </Card>
        </Col>
        <Col flex="auto">
          <div style={{ marginBottom: "12px" }}>
            <h4 style={{ marginBottom: "8px" }}> Mulching </h4>
            <div className="reviewCarousel">
              <div className="innerCarousel">
                <div className="attachmentTag">
                  <Tag className="shaded_green_tag">Before</Tag>
                </div>
                <Carousel arrows infinite={false}>
                  <div>
                    <img
                      src="/images/work-orders/ls_1.png"
                      alt="Attachment 1"
                      style={{
                        width: "100%",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      src="/images/work-orders/ls_1.png"
                      alt="Attachment 1"
                      style={{
                        width: "100%",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      src="/images/work-orders/ls_1.png"
                      alt="Attachment 1"
                      style={{
                        width: "100%",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </Carousel>
              </div>
              <div className="innerCarousel">
                <div className="attachmentTag">
                  <Tag className="shaded_red_tag">After</Tag>
                </div>
                <Carousel arrows infinite={false}>
                  <div>
                    <img
                      src="/images/work-orders/ls_2.png"
                      alt="Attachment 1"
                      style={{
                        width: "100%",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      src="/images/work-orders/ls_2.png"
                      alt="Attachment 1"
                      style={{
                        width: "100%",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      src="/images/work-orders/ls_2.png"
                      alt="Attachment 1"
                      style={{
                        width: "100%",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </Carousel>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: "12px" }}>
            <h4 style={{ marginBottom: "8px" }}> Hard edging </h4>
            <div className="reviewCarousel">
              <div className="innerCarousel">
                <div className="attachmentTag">
                  <Tag className="shaded_green_tag">Before</Tag>
                </div>
                <Carousel arrows infinite={false}>
                  <div>
                    <img
                      src="/images/work-orders/ls_2.png"
                      alt="Attachment 1"
                      style={{
                        width: "100%",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      src="/images/work-orders/ls_2.png"
                      alt="Attachment 1"
                      style={{
                        width: "100%",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      src="/images/work-orders/ls_2.png"
                      alt="Attachment 1"
                      style={{
                        width: "100%",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </Carousel>
              </div>
              <div className="innerCarousel">
                <div className="attachmentTag">
                  <Tag className="shaded_red_tag">After</Tag>
                </div>
                <Carousel arrows infinite={false}>
                  <div>
                    <img
                      src="/images/work-orders/ls_2.png"
                      alt="Attachment 1"
                      style={{
                        width: "100%",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      src="/images/work-orders/ls_2.png"
                      alt="Attachment 1"
                      style={{
                        width: "100%",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div>
                    <img
                      src="/images/work-orders/ls_2.png"
                      alt="Attachment 1"
                      style={{
                        width: "100%",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </Carousel>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}
